import script from "./MisClientes.vue?vue&type=script&setup=true&lang=js"
export * from "./MisClientes.vue?vue&type=script&setup=true&lang=js"

import "./MisClientes.vue?vue&type=style&index=0&id=2222d224&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2222d224"]])

export default __exports__